import axios from "@/plugins/axios";

let url = "/api/v1/shop/coupons";

export default {
    getCoupons(data){
        return axios.get(url, data).then(result => result.data);
    },
}
